<template>
  <v-container
    fluid
  >
    <v-form>
      <v-container>
        <v-btn
          class="ma-2 float-left"
          tile
          outlined
          :loading="btnLoading"
          :disabled="btnLoading"
          color="success"
          @click="save()"
        >
          <v-icon
            left
          >
            mdi-check
          </v-icon>
          {{ $t('save') }}
        </v-btn>
        <v-subheader
          class="display-1"
        >
          {{ $t('operations_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="BlogCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template
                  v-slot:append
                >
                  <v-text-field
                    v-model="BlogCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="blogValue"
                :items="blogItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-subheader
          class="display-1"
        >
          {{ $t('category_settings') }}
        </v-subheader>
        <v-card-text>
          <v-row>
            <v-col
              md="12"
            >
              <v-subheader>{{ $t('table_row_count') }}</v-subheader>
              <v-slider
                v-model="BlogCategoriesCPP"
                class="align-center"
                :max="max"
                :min="min"
                hide-details
              >
                <template v-slot:append>
                  <v-text-field
                    v-model="BlogCategoriesCPP"
                    class="mt-0 pt-0"
                    hide-details
                    single-line
                    type="number"
                    style="width: 60px"
                  />
                </template>
              </v-slider>
            </v-col>
            <v-col
              md="12"
            >
              <v-select
                v-model="blogCategoriesValue"
                :items="blogCategoriesItems"
                item-text="display"
                item-value="dbitem"
                :label="$t('columns')"
                chips
                dense
                multiple
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="6000"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          tile
          small
          outlined
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    name: 'Settings',
    data: () => ({
      btnLoading: false,
      valid: false,
      BlogCPP: 0,
      BlogCategoriesCPP: 0,
      min: 1,
      max: 100,
      blogItems: [],
      blogValue: [],
      blogCategoriesItems: [],
      blogCategoriesValue: [],
      dynamicColumns: [],
      snackbar: false,
      snackbarColor: '', // ['success', 'info', 'error', 'cyan darken-2']
      snackbarText: '',
    }),
    async created () {
      await this.getOptions()
      await this.getDynamicColumns()
      await this.getBlogCategoriesColumns()
    },
    methods: {
      getOptions () {
        this.$http.post('options/showLikeTitle', {
          title: 'Blog',
        }).then(
          response => {
            const result = response.data.Option
            this.BlogCPP = parseInt(result.find(x => x.title === 'Blog-CPP').value)
            this.BlogCategoriesCPP = parseInt(result.find(x => x.title === 'Blog-Categories-CPP').value)
            let tempValue = result.filter(x => x.title === 'Blog-TH-Operations')
            let tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.blogValue = tempArray

            tempValue = result.filter(x => x.title === 'Blog-TH-Category')
            tempArray = []
            tempValue.forEach(function (value) {
              tempArray.push(value.value)
            })
            this.blogCategoriesValue = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/showLikeTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/showLikeTitle|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getBlogColumns () {
        this.$http.post('blog/columns').then(
          response => {
            const result = response.data.BlogColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({
                dbitem: value,
                display: self.$t((typeof self.dynamicColumns[value] !== 'undefined') ? self.dynamicColumns[value] : value),
              })
            })
            this.blogItems = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': blog/columns|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': blog/columns|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getBlogCategoriesColumns () {
        this.$http.post('blog/categoriesColumns').then(
          response => {
            const result = response.data.BlogCategoriesColumns
            const tempArray = []
            const self = this
            result.forEach(function (value) {
              tempArray.push({ dbitem: value, display: self.$t(value) })
            })
            this.blogCategoriesItems = tempArray
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': blogCategories/columns|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': blogCategories/columns|902'
          this.snackbar = true
          console.log(error)
        })
      },
      getDynamicColumns () {
        this.$http.post('dynamicColumns/showByTable', {
          table: 'blog',
        }).then(
          response => {
            const result = response.data.DynamicColumns
            result.forEach(o => {
              this.dynamicColumns[o.column] = o.title
            })
            this.getBlogColumns()
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': dynamicColumns/showByTable|902'
          this.snackbar = true
          console.log(error)
        })
      },
      save () {
        this.btnLoading = true
        const temparray = []
        this.blogValue.forEach(o => {
          temparray.push({ title: 'Blog-TH-Operations', value: o, language_id: 1 })
        })
        this.blogCategoriesValue.forEach(o => {
          temparray.push({ title: 'Blog-TH-Category', value: o, language_id: 1 })
        })
        this.$http.post('options/destroyAndInsertByTitle', {
          title: ['Blog-TH-Operations', 'Blog-TH-Category'],
          insertArray: temparray,
        }).then(
          response => {
            this.snackbarColor = 'success'
            this.snackbarText = this.$t('item_updated')
            this.snackbar = true
          },
          error => {
            this.snackbarColor = 'error'
            this.snackbarText = this.$t('server_error') + ': options/destroyAndInsertByTitle|901'
            this.snackbar = true
            console.log(error)
          }).catch(error => {
          this.snackbarColor = 'error'
          this.snackbarText = this.$t('server_error') + ': options/destroyAndInsertByTitle|902'
          this.snackbar = true
          console.log(error)
        })
        this.btnLoading = false
        // TODO: Save BlogCategoriesColumns and Other
      },
    },
  }
</script>

<style scoped>

</style>
